<template>
  <div style="width: 12.8rem; margin: 0 auto; padding-top: 0.7rem;padding-bottom: .24rem;">

    <div v style="min-height: 2.72rem;border-radius: .08rem;background: #FFF;margin-top: .24rem;padding: .24rem;">
      <el-skeleton :rows="6" v-if="loading" />
      <div v-else>
        <div
          v-if="detailData.type == 1 ? detailData.orderState != 2 && !playerOptions.sources[0].src : detailData.type == 2"
          class="" style="display: flex;column-gap: .24rem;">
          <div class="" style="width: 4rem;height: 2.24rem;border-radius: .08rem;">
            <img :src="detailData.image" style="width: 4rem;height: 2.24rem;border-radius: .08rem;" alt="" srcset="">
          </div>
          <div class="" style="flex: 1;">
            <div style=" font-size: .2rem; font-weight: 700; color: #000000;"><span>{{ detailData.title }}</span></div>
            <div style=" color: #90969c; font-size: 14px; color: #90969c;"><span>{{ detailData.content }}</span>
            </div>
            <div
              style="height: .6rem;background-color: #F5F5F5;border-radius: 0.08rem;padding: 0 .12rem;margin-top: 0.12rem;display: flex;align-items: center;column-gap:.4rem ">
              <div style="line-height: .6rem;">
                <span style=" color: #c01a26; font-size: .2rem; font-weight: 500;">￥</span>
                <span style=" font-size: .4rem; font-weight: 500; color: #c01a26;">{{ detailData.price }}</span>
              </div>
              <div v-if="detailData.type == 2">
                <div style=" color: #90969c; font-size: 12px; font-weight: 400;">
                  <span>上课时间</span>
                </div>
                <div style=" color: #333333; font-size: 14px; font-weight: 700;margin-top: 8px;">
                  <span>{{ detailData.startTime }}至{{ detailData.endTime }}</span>
                </div>
              </div>
              <div v-if="detailData.type == 2">
                <div style=" color: #90969c; font-size: 12px; font-weight: 400;">
                  <span>招生人数</span>
                </div>
                <div style=" color: #333333; font-size: 14px; font-weight: 700;margin-top: 8px;">
                  <span>{{ detailData.signUpNumber }}人</span>
                </div>
              </div>
            </div>
            <!--  -->
            <div v-if="detailData.type == 2"
              style="height: .34rem;background: #ffede3;border-radius: 8px; color: #ff8741; font-size: 12px;line-height: .34rem;padding-left: 8px;margin-top: .12rem;">
              <span>购买成功线下课程后，可前往头像-我的课程-课程订单中进行退款操作，开课7日前不可退款，敬请谅解！</span>
            </div>
            <!--  -->
            <div style="display: flex;align-items: center;column-gap: 15px;margin-top: .56rem;">
              <div
                v-if="detailData.type == 1 && (detailData.orderState == 1 || detailData.orderState == 3 || detailData.orderState == null)"
                @click="detailData.orderState == 1 ? $router.push('/myCourse?id=' + detailData.courseId) : $router.push('/orderDetail?id=' + detailData.courseId)"
                style="width: 2rem;background: #C01A26;border-radius: 0.08rem;height: .45rem;text-align: center;line-height: .45rem;color: #FFF;cursor: pointer;">
                <span>{{ detailData.orderState == 1 ? '立即支付' : '立即购买' }}</span>
              </div>
              <!--  -->
              <div
                v-if="detailData.type == 2 && new Date(detailData.startTime).getTime() > new Date().getTime() && (detailData.orderState == 1 || detailData.orderState == 3 || detailData.orderState == null || detailData.orderState == 2)"
                @click="detailData.orderState == 1 ? $router.push('/myCourse?id=' + detailData.courseId) : detailData.orderState == 2 ? '' : $router.push('/signMsg?id=' + detailData.courseId)"
                :style="['width: 2rem;border-radius: 0.08rem;height: .45rem;text-align: center;line-height: .45rem;cursor: pointer;', detailData.orderState == 2 ? 'background: #E4E8EC;color:#333333' : 'color: #FFF;background: #C01A26;']">
                <span>{{ detailData.orderState == 1 ? '立即支付' : detailData.orderState == 2 ? '已报名' : '立即报名' }}</span>
              </div>
              <div @click="collectBtn"
                :style="['width: 2rem;border-radius: 0.08rem;height: .45rem;text-align: center;line-height: .45rem;cursor: pointer;', detailData.collectFlag ? 'background: #E4E8EC;color:#333333' : 'color: #FFF;background: #C01A26;']">
                <span>{{ detailData.collectFlag ? '已收藏' : "收藏" }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="body_left_video" style="background: #000;border-radius: 8px;">
          <video-player id="myVideo" @timeupdate="timeupdate" @ready="playerReadied" @play="handlePlay"
            class="custom-video-player" ref="videoPlayer" :options="playerOptions"></video-player>
          <div
            style="background: #000000;display: flex;justify-content: space-between;align-items: center;padding: 0 0 .24rem;margin: .2rem 0;">
            <div style=" color: #ffffff; font-size: 17px; font-weight: 700;border-radius: 8px;"><span>{{ detailData.title
            }}</span></div>
            <div style="height: .58rem;min-width: .61rem;background: #282828;border-radius: 8px;padding: .10rem;">
              <div style=" color: #ffffff; font-size: 12px; font-weight: 400;"><span>学习进度</span></div>
              <div><span style=" color: #4bc185; font-size: 20px; font-weight: 700;">{{ detailData.progress }}</span><span
                  style=" color: #4bc185; font-size: 10px; font-weight: 700;">%</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div style="margin-top: .24rem;border-radius: 0.08rem;display: flex;column-gap: .24rem;">
      <!-- left -->
      <div style="flex: 1;background: #FFF;border-radius: 0.08rem;">
        <div style="height: .45rem;display: flex;column-gap: .4rem;padding: 0 .12rem;">
          <div @click="type = 1"
            :style="[' font-size: .14rem;position: relative;cursor: pointer;', type == 1 ? 'color: #c01a26; font-weight: 700;' : 'color: #333333;font-weight: 400;']">
            <span style="line-height: .45rem;">课程介绍</span>
            <span v-if="type == 1"
              style="display: inline-block;height: 5px;background: #c01a26;width: 100%;position: absolute;bottom: 0;left:0;border-radius: .08rem;"></span>
          </div>
          <div @click="type = 2"
            :style="[' font-size: .14rem;position: relative;cursor: pointer;', type == 2 ? 'color: #c01a26; font-weight: 700;' : 'color: #333333;font-weight: 400;']">
            <span style="line-height: .45rem;">课程目录</span>
            <span v-if="type == 2"
              style="display: inline-block;height: 5px;background: #c01a26;width: 100%;position: absolute;bottom: 0;left:0;border-radius: .08rem;"></span>
          </div>
        </div>
        <!--  -->
        <div style="padding: .24rem;" class="c" v-if="type == 1">
          <el-skeleton :rows="10" v-if="loading" />
          <div style="border-radius: .08rem;" v-else v-html="decodeURIComponent(detailData.richTextBrief)"></div>
        </div>
        <div v-if="type == 2" style="padding: .24rem;">
          <div style="">
            <span style=" color: #333333; font-size: .16rem; font-weight: 500;">课程详情</span>
            <span v-if="detailData.type == 1"
              style=" color: #90969c; font-size: .16rem; font-weight: 400;margin-left: .12rem;">{{
                detailData.totalLesson }}课时</span>
          </div>
          <div style="margin-top: .13rem;">
            <el-steps direction="vertical" :active="1">
              <el-step title="Step 1" v-for="(item, index) in detailData.courseCatalogueVOS" :key="item.catalogueId">
                <template #title>
                  <div style=" color: #000000; font-weight: 700; font-size: .14rem">
                    <span v-if="detailData.type == 1">{{ index + 1 }}、</span>
                    <span>{{ item.title }}</span>
                  </div>
                </template>
                <template #description>
                  <div v-if="detailData.type == 1" @click="detailData.type == 1 ? goToVideo(item_) : ''"
                    v-for="item_ in item.barVOS" :key="item.catalogueId + item_.barId" class="l"
                    style="display: flex;align-items: center;column-gap: 5px;height: .45rem;line-height: .45rem;padding: 0 .13rem;cursor: pointer;justify-content: space-between;">
                    <div style="display: flex;align-items: center;column-gap: 5px;">
                      <div style="" v-if="detailData.type == 1">
                        <img style="width: .16rem;height: .16rem;" src="@/assets/grzx_wdsc.png" alt="">
                      </div>
                      <div style="display: flex;align-items: center;column-gap: .04rem;">
                        <div style=" color: #333333; font-weight: 400; font-size: .14rem;">
                          <span> {{ item_.title }}</span>
                        </div>
                        <div v-if="item_.tryHearFlag == 2 && detailData.type == 1"
                          style="border-radius: .04rem;border: 1px solid #C01A26; font-size: .12rem; font-weight: 400;width: 0.36rem;height: .22rem;text-align: center;line-height: .22rem;color: #C01A26;">
                          <span>试听</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="detailData.type == 1 && detailData.orderState == 2"
                      :style="[item_.watchFlag == 1 ? ' color: #90969c; font-size: .14rem;' : ' color: #10b981; font-size: .14rem;']">
                      <span>{{ item_.watchFlag == 1 ? '未观看' : '已观看' }}</span>
                    </div>
                  </div>
                  <div v-else>
                    <div v-for="item_ in item.barVOS" :key="item.catalogueId + item_.barId">
                      <div style=" color: #333333; font-weight: 400; font-size: .14rem;">
                        <span>{{ item_.title }}</span>
                      </div>
                      <div style="color: #a9aaae;font-size: .14rem;">
                        <div v-for="c in item_.content.split(';')" style="margin-top: 8px;" :key="c">
                          <span>{{ c }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-step>
            </el-steps>
          </div>
        </div>
      </div>
      <!-- right -->
      <div v-if="loading">
        <el-skeleton v-for="item in 2" :key="item" :loading="loading" :throttle="{ trailing: 1000 }" :animated="true">
          <template #template>
            <el-skeleton-item variant="image" style="width: 2.6rem;height: 1.58rem;" />
            <div style="padding: 14px">
              <el-skeleton-item variant="h3" style="width: 30%" />
              <el-skeleton-item variant="text" style="margin-right: 16px" />
            </div>
          </template>
        </el-skeleton>
      </div>
      <div v-else style="gap: 0.24rem;background: #f5f5f5;display: flex;flex-direction: column;">
        <moduleSEProvideMaterial v-for="item in detailData.recommendCourseList" :key="item.id" :item="item"
          class="SL_offerMaterialListdiv cur">
        </moduleSEProvideMaterial>
      </div>

    </div>
  </div>
</template>

<script  setup>
import { ref, nextTick, watch } from 'vue'
import { Axios } from "../../assets/js/ls_com_axios.js";
import moduleSEProvideMaterial from "../../components/moduleSEProvideMaterial.vue";
import { ElMessage, ElMessageBox } from "element-plus"
import { useRoute } from 'vue-router';
const type = ref(1);
const route = useRoute();
let urlData = new URLSearchParams(location.search);
const detailData = ref({});
const loading = ref(true);

const playerOptions = ref({
  autoplay: false,
  controls: true,
  muted: false,
  controlBar: {
    durationDisplay: true,
    volumePanel: {
      inline: false,
    },
  },
  sources: [
    {
      src: "",
      type: "video/mp4",
    },
  ],
});
const collectBtn = () => {
  ElMessageBox.confirm(
    detailData.value.collectFlag ? '是否取消收藏？' : "是否收藏？",
    '',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'orderDetail',
      confirmButtonClass: "",
      center: true,
      closeOnClickModal: false
    }
  )
    .then(() => {
      Axios(
        "get",
        "/system/courseWeb/collect",
        {
          courseId: detailData.value.courseId
        },
        false,
        (res) => {
          if (res.data.code == 200) {
            detailData.value.collectFlag = !detailData.value.collectFlag
          } else {
            ElMessage.error(res.data.msg)
          }
        }, () => {
        })
    }).catch(() => {

    })
}
const barId_timter = ref("");
const timeupdate = (timer) => {
  localStorage.setItem(barId_timter.value, timer.cache_.currentTime);
}
const playerReadied = (player) => {
  player.currentTime(localStorage.getItem(barId_timter.value) || 0);
}
const playItemId = ref({});
const handlePlay = () => {
  console.log(playItemId.value)
  Object.keys(playItemId.value).length && playItemId.value.watchFlag == 1 && Axios(
    "get",
    "/system/courseWeb/watch",
    {
      courseBarId: playItemId.value.barId
    },
    false,
    (res) => {
      if (res.data.code == 200) {
        barId_timter.value = playItemId.value.barId;
        playerOptions.value.sources[0].src = playItemId.value.videoUrl;
        playItemId.value.watchFlag = 2;
      } else {
        ElMessage({
          message: res.data.msg,
          type: 'warning',
        })
      }
    },
    () => {
      playerOptions.value.sources[0].src = '';
    })
  console.log("开始播放")
}
watch(() => route.params, (newParams) => {
  urlData = new URLSearchParams(location.search);
  getList()
});
const getList = () => {
  loading.value = true;
  Axios(
    "get",
    "/system/courseWeb/catalogue",
    {
      courseId: urlData.get('id')
    },
    false,
    (res) => {
      detailData.value = res.data.data;
      res.data.data.orderState == 2 && (playerOptions.value.sources[0].src = detailData.value.courseCatalogueVOS.length ? detailData.value.courseCatalogueVOS[0].barVOS.length ? detailData.value.courseCatalogueVOS[0].barVOS[0].videoUrl : '' : '');
      res.data.data.orderState == 2 && (barId_timter.value = detailData.value.courseCatalogueVOS.length ? detailData.value.courseCatalogueVOS[0].barVOS.length ? detailData.value.courseCatalogueVOS[0].barVOS[0].barId : '' : '');
      res.data.data.orderState == 2 && (playItemId.value = detailData.value.courseCatalogueVOS.length ? detailData.value.courseCatalogueVOS[0].barVOS.length ? detailData.value.courseCatalogueVOS[0].barVOS[0] : {} : {});
      loading.value = false;
    },
    () => {
      loading.value = false;
      detailData.value = {};
    })
}
getList()
const goToVideo = (item) => {
  if (localStorage.getItem("token") == null) {
    router.push({
      path: "/TgLogin",
      query: {
        url: location.href
      }
    });
    return
  }
  if (detailData.value.orderState == 2 || item.tryHearFlag == 2) {
    item.tryHearFlag == 2 && (barId_timter.value = item.barId, playerOptions.value.sources[0].src = item.videoUrl);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    detailData.value.orderState == 2 && (playItemId.value = item);
  } else {
    ElMessage({
      message: '请先购买课程',
      type: 'warning',
    });
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
      playerOptions.value.sources[0].src = '';
    }, 0);
  }
}
// const progressList = () => {
//   Axios(
//     "get",
//     "/system/courseWeb/progress",
//     {

//     },
//     false,
//     (res) => {
//       console.log(res)
//     }, () => {

//     })
// }
// progressList()
</script>
<style scoped lang="less">
/deep/.c img {
  border-radius: 8px;
  width: 100% !important;
}

.l:hover {
  background: #F5F5F5;
  border-radius: 8px;
}

/deep/.el-step__icon-inner {
  display: none;
}

/deep/.el-step__icon {
  width: 8px;
  height: 8px;
  position: absolute;
  top: 0;
  margin-left: .08rem;
  background-color: #90969C;
}

/deep/.el-step__head.is-finish,
/deep/.el-step__head.is-process,
/deep/.el-step__head.is-wait {
  color: #C01A26 !important;
  border-color: #90969C !important;
  // margin-top: .06rem;
}

/deep/.el-step__description {
  padding-right: 0 !important;
}

/deep/.body_left_video {
  min-height: 4.82rem;
  height: auto;
  border-radius: 8px !important;
  padding: 0 2.18rem;
}

/deep/.custom-video-player,
/deep/.video-js {
  width: 100% !important;
  height: 4.82rem !important;
  // border-radius: 8px;
}

/deep/.video-js .vjs-tech {
  object-fit: inherit;
}
</style>
<style lang="less">
.orderDetail .el-message-box__title {
  font-size: 60px !important;
  padding-left: 25px !important;
}

.orderDetail {
  border-radius: 12px !important;
}

.orderDetail .el-message-box__btns {
  button {
    width: 88px !important;
    line-height: 32px !important;
    text-align: center;
    line-height: 32px;
  }
}

.orderDetail .el-button--primary {
  background: #C01A26;
  border: 1px solid #C01A26;
}

.orderDetail .el-button:focus-visible {
  outline: 2px solid #C01A26;
}

.orderDetail .el-message-box__headerbtn:focus .el-message-box__close,
.el-message-box__headerbtn:hover .el-message-box__close {
  color: #C01A26;
}
</style>